import { getItem, STORAGE_KEYS } from '../services/storage';
import { MATRICULAS_SOLO_LECTURA } from '../helpers/constants';

// Hook síncrono que indica si el usuario actual solo puede consultar matrículas
// (todos los controles de mutación quedan deshabilitados).

export default function useSoloLecturaMatriculas() {
  const user = getItem(STORAGE_KEYS.USER);
  const email = user?.profileObj?.email?.toLowerCase?.() ?? '';
  return MATRICULAS_SOLO_LECTURA.includes(email);
}
